export default "__VITE_ASSET__BlxYf2tl__"